<template>
  <div class="history-block-bar"  :class="{v_true: contentData.data.list[0].video && contentData.data.list[0].video.videoFile && contentData.data.list[0].video.videoFile.url}">
    <div class="img-wrapper" :class="{v_true: contentData.data.list[0].video && contentData.data.list[0].video.videoFile && contentData.data.list[0].video.videoFile.url}">
      <video :src="video_url" loop v-if="contentData.data.list[0].video && contentData.data.list[0].video.videoFile && contentData.data.list[0].video.videoFile.url"
      muted ref="bar_block_video" class="b__v"
      ></video>
      <img
        :src="_.get(contentData, 'data.list[0].images[0].url')"
        alt=""
        class="block-img ik_prlx"
        data-scroll
        data-scroll-speed="-1.2"
        prlx-intensity="20"
        v-else
      />
    </div>
    <div id="jjjvibe" v-html="_.get(contentData, 'data.list[0].svg')"></div>

    <div class="container-bar">
      <div class="text-block">
      <div class="upper-col" v-html="_.get(contentData, 'data.list[0].svg2')">
     
    


      </div>

        <h2 class="f-55 bold-italic">
       {{_.get(contentData, 'data.list[0].title') }}
        </h2>
        <div class="editor-bar" v-html="_.get(contentData, 'data.list[0].teaser')"></div>
        <div class="lower-col">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="285.999"
            height="55.742"
            viewBox="0 0 285.999 55.742"
          >
            <g
              id="Group_448"
              data-name="Group 448"
              transform="translate(-151.635 -280.655)"
            >
              <g
                id="Group_127"
                data-name="Group 127"
                transform="translate(151.635 280.655)"
              >
                <rect
                  id="Rectangle_509"
                  data-name="Rectangle 509"
                  width="2.854"
                  height="35.609"
                  transform="translate(5.721)"
                  fill="#101820"
                />
                <rect
                  id="Rectangle_510"
                  data-name="Rectangle 510"
                  width="2.854"
                  height="35.609"
                  fill="#101820"
                />
                <rect
                  id="Rectangle_511"
                  data-name="Rectangle 511"
                  width="5.723"
                  height="35.609"
                  transform="translate(11.435)"
                  fill="#101820"
                />
                <rect
                  id="Rectangle_512"
                  data-name="Rectangle 512"
                  width="8.583"
                  height="35.609"
                  transform="translate(20.02)"
                  fill="#101820"
                />
                <rect
                  id="Rectangle_513"
                  data-name="Rectangle 513"
                  width="2.856"
                  height="35.609"
                  transform="translate(40.043)"
                  fill="#101820"
                />
                <rect
                  id="Rectangle_514"
                  data-name="Rectangle 514"
                  width="2.856"
                  height="35.609"
                  transform="translate(45.769)"
                  fill="#101820"
                />
                <rect
                  id="Rectangle_515"
                  data-name="Rectangle 515"
                  width="5.726"
                  height="35.609"
                  transform="translate(57.204)"
                  fill="#101820"
                />
                <rect
                  id="Rectangle_516"
                  data-name="Rectangle 516"
                  width="2.859"
                  height="35.609"
                  transform="translate(65.788)"
                  fill="#101820"
                />
                <rect
                  id="Rectangle_517"
                  data-name="Rectangle 517"
                  width="5.724"
                  height="35.609"
                  transform="translate(77.227)"
                  fill="#101820"
                />
                <rect
                  id="Rectangle_518"
                  data-name="Rectangle 518"
                  width="2.856"
                  height="35.609"
                  transform="translate(105.833)"
                  fill="#101820"
                />
                <rect
                  id="Rectangle_519"
                  data-name="Rectangle 519"
                  width="2.856"
                  height="35.609"
                  transform="translate(100.113)"
                  fill="#101820"
                />
                <rect
                  id="Rectangle_520"
                  data-name="Rectangle 520"
                  width="2.855"
                  height="35.609"
                  transform="translate(85.808)"
                  fill="#101820"
                />
                <rect
                  id="Rectangle_521"
                  data-name="Rectangle 521"
                  width="8.581"
                  height="35.609"
                  transform="translate(111.554)"
                  fill="#101820"
                />
                <rect
                  id="Rectangle_522"
                  data-name="Rectangle 522"
                  width="2.86"
                  height="35.609"
                  transform="translate(137.296)"
                  fill="#101820"
                />
                <rect
                  id="Rectangle_523"
                  data-name="Rectangle 523"
                  width="2.855"
                  height="35.609"
                  transform="translate(131.578)"
                  fill="#101820"
                />
                <rect
                  id="Rectangle_524"
                  data-name="Rectangle 524"
                  width="2.862"
                  height="35.609"
                  transform="translate(92.357)"
                  fill="#101820"
                />
                <rect
                  id="Rectangle_525"
                  data-name="Rectangle 525"
                  width="2.851"
                  height="35.609"
                  transform="translate(209.701)"
                  fill="#101820"
                />
                <rect
                  id="Rectangle_526"
                  data-name="Rectangle 526"
                  width="2.856"
                  height="35.609"
                  transform="translate(125.856)"
                  fill="#101820"
                />
                <rect
                  id="Rectangle_527"
                  data-name="Rectangle 527"
                  width="8.57"
                  height="35.609"
                  transform="translate(143.02)"
                  fill="#101820"
                />
                <rect
                  id="Rectangle_528"
                  data-name="Rectangle 528"
                  width="2.857"
                  height="35.609"
                  transform="translate(157.317)"
                  fill="#101820"
                />
                <rect
                  id="Rectangle_529"
                  data-name="Rectangle 529"
                  width="5.717"
                  height="35.609"
                  transform="translate(174.477)"
                  fill="#101820"
                />
                <rect
                  id="Rectangle_530"
                  data-name="Rectangle 530"
                  width="5.722"
                  height="35.609"
                  transform="translate(163.038)"
                  fill="#101820"
                />
                <rect
                  id="Rectangle_531"
                  data-name="Rectangle 531"
                  width="2.854"
                  height="35.609"
                  transform="translate(183.064)"
                  fill="#101820"
                />
                <rect
                  id="Rectangle_532"
                  data-name="Rectangle 532"
                  width="8.579"
                  height="35.609"
                  transform="translate(188.787)"
                  fill="#101820"
                />
                <rect
                  id="Rectangle_533"
                  data-name="Rectangle 533"
                  width="2.862"
                  height="35.609"
                  transform="translate(203.086)"
                  fill="#101820"
                />
                <rect
                  id="Rectangle_534"
                  data-name="Rectangle 534"
                  width="2.857"
                  height="35.609"
                  transform="translate(217.391)"
                  fill="#101820"
                />
                <rect
                  id="Rectangle_535"
                  data-name="Rectangle 535"
                  width="5.721"
                  height="35.609"
                  transform="translate(254.571)"
                  fill="#101820"
                />
                <rect
                  id="Rectangle_536"
                  data-name="Rectangle 536"
                  width="5.724"
                  height="35.609"
                  transform="translate(231.682)"
                  fill="#101820"
                />
                <rect
                  id="Rectangle_537"
                  data-name="Rectangle 537"
                  width="5.723"
                  height="35.609"
                  transform="translate(243.131)"
                  fill="#101820"
                />
                <rect
                  id="Rectangle_538"
                  data-name="Rectangle 538"
                  width="5.72"
                  height="35.609"
                  transform="translate(223.106)"
                  fill="#101820"
                />
                <rect
                  id="Rectangle_539"
                  data-name="Rectangle 539"
                  width="2.854"
                  height="35.609"
                  transform="translate(263.156)"
                  fill="#101820"
                />
                <rect
                  id="Rectangle_540"
                  data-name="Rectangle 540"
                  width="2.856"
                  height="35.609"
                  transform="translate(268.875)"
                  fill="#101820"
                />
              </g>
              <g
                id="Group_128"
                data-name="Group 128"
                transform="translate(151.996 321.004)"
              >
                <path
                  id="Path_441"
                  data-name="Path 441"
                  d="M155.361,341.218a2.213,2.213,0,0,0,1.834.843,2.333,2.333,0,0,0,1.866-.894,2.978,2.978,0,0,0,.7-1.98,4.963,4.963,0,0,0-.052-.888,2.358,2.358,0,0,0-.9-1.4,2.451,2.451,0,0,0-1.528-.525,2.2,2.2,0,0,0-1.345.44,2.358,2.358,0,0,0-1.394-.44,2.425,2.425,0,0,0-1.706.665,2.3,2.3,0,0,0-.765,1.782v.434a3.953,3.953,0,0,0,.982,2.653h-.642l-.01.989h.5q3.988.025,5.426,3.089l.209.448.9-.424a6.919,6.919,0,0,0-4.116-3.8,2.95,2.95,0,0,1-2.259-2.964v-.434a1.451,1.451,0,0,1,1.463-1.452,1.354,1.354,0,0,1,.739.192,3.262,3.262,0,0,0-.5,1.8A2.89,2.89,0,0,0,155.361,341.218Zm.516-2.679a2.737,2.737,0,0,1,.563-.867,1.329,1.329,0,0,1,.878-.308,1.531,1.531,0,0,1,.974.339,1.228,1.228,0,0,1,.478.89c.008.123.014.249.014.374q0,2.107-1.588,2.1a1.424,1.424,0,0,1-1.033-.422,1.364,1.364,0,0,1-.42-1.024A3.383,3.383,0,0,1,155.876,338.539Z"
                  transform="translate(-152.076 -331.057)"
                  fill="#101820"
                />
                <path
                  id="Path_442"
                  data-name="Path 442"
                  d="M170.754,336.269a1.444,1.444,0,0,1-.862-.627,3.741,3.741,0,0,1-.36-1.006l-.958.241.117.48a2.331,2.331,0,0,0,1.039,1.46l1.347.742a1.532,1.532,0,0,1,.666,1.337,1.572,1.572,0,0,1-.67,1.361,2.462,2.462,0,0,1-1.473.426,2.494,2.494,0,0,1-1.472-.418,1.58,1.58,0,0,1-.675-1.369,1.655,1.655,0,0,1,.235-.865l.243-.434-.852-.485a3.77,3.77,0,0,0-.611,1.783,2.506,2.506,0,0,0,.967,2.07,3.664,3.664,0,0,0,4.323,0,2.514,2.514,0,0,0,.964-2.07,2.672,2.672,0,0,0-.554-1.651A2.634,2.634,0,0,0,170.754,336.269Z"
                  transform="translate(-154.673 -330.743)"
                  fill="#101820"
                />
                <path
                  id="Path_443"
                  data-name="Path 443"
                  d="M183.12,330.743a3.269,3.269,0,0,0-2.173.742,2.589,2.589,0,0,0-.961,2.094,4.087,4.087,0,0,0,.483,1.633l.888-.418a3.224,3.224,0,0,1-.389-1.215,1.652,1.652,0,0,1,.674-1.389,2.36,2.36,0,0,1,1.479-.457,2.33,2.33,0,0,1,1.467.45,1.635,1.635,0,0,1,.675,1.392v2.464a2.558,2.558,0,0,0-1.81-.674,2.807,2.807,0,1,0,2.792,2.8v-4.6a2.575,2.575,0,0,0-.956-2.094A3.278,3.278,0,0,0,183.12,330.743Zm1.606,8.706a1.81,1.81,0,1,1,.008-2.562,1.835,1.835,0,0,1-.008,2.562Z"
                  transform="translate(-157.112 -330.041)"
                  fill="#101820"
                />
                <path
                  id="Path_444"
                  data-name="Path 444"
                  d="M198.115,335.6l1.424-1.074-.6-.788-2.449,1.848a6.149,6.149,0,0,0,.525-2.087,6.822,6.822,0,0,0,0-.689,2.065,2.065,0,0,0-.629-1.459,1.993,1.993,0,0,0-1.457-.6,1.9,1.9,0,0,0-1.585.757,2.844,2.844,0,0,0,0,3.3,1.914,1.914,0,0,0,1.585.749,2.072,2.072,0,0,0,.618-.093q-.5,1.253-.525,1.36a4.4,4.4,0,0,0-.27,1.431,2.723,2.723,0,0,0,5.446,0,2.734,2.734,0,0,0-2.087-2.652Zm-3.178-1.034a1,1,0,0,1-.854-.438,1.629,1.629,0,0,1-.282-.967,1.58,1.58,0,0,1,.289-.973.971.971,0,0,1,.847-.45,1.064,1.064,0,0,1,.781.326,1.019,1.019,0,0,1,.318.778,9,9,0,0,1-.015.983A1.318,1.318,0,0,1,194.938,334.562Zm3.771,4.911a1.744,1.744,0,0,1-2.46,0,1.645,1.645,0,0,1-.509-1.224,1.752,1.752,0,0,1,1.736-1.738,1.742,1.742,0,0,1,1.744,1.738A1.651,1.651,0,0,1,198.709,339.473Z"
                  transform="translate(-159.427 -330.041)"
                  fill="#101820"
                />
                <path
                  id="Path_445"
                  data-name="Path 445"
                  d="M211.313,336.269a1.439,1.439,0,0,1-.863-.627,3.741,3.741,0,0,1-.36-1.006l-.958.241.117.48a2.336,2.336,0,0,0,1.037,1.46c.45.248.9.493,1.347.742a1.527,1.527,0,0,1,.67,1.337,1.572,1.572,0,0,1-.67,1.361,2.455,2.455,0,0,1-1.473.426,2.494,2.494,0,0,1-1.472-.418,1.583,1.583,0,0,1-.676-1.369,1.664,1.664,0,0,1,.237-.865l.243-.434-.852-.485a3.77,3.77,0,0,0-.611,1.783,2.5,2.5,0,0,0,.967,2.07,3.669,3.669,0,0,0,4.327,0,2.518,2.518,0,0,0,.961-2.07,2.659,2.659,0,0,0-.556-1.651A2.623,2.623,0,0,0,211.313,336.269Z"
                  transform="translate(-161.991 -330.743)"
                  fill="#101820"
                />
                <path
                  id="Path_446"
                  data-name="Path 446"
                  d="M222.958,341.218a2.214,2.214,0,0,0,1.83.843,2.339,2.339,0,0,0,1.872-.894,3.015,3.015,0,0,0,.7-1.98,4.823,4.823,0,0,0-.055-.888,2.342,2.342,0,0,0-.895-1.4,2.459,2.459,0,0,0-1.53-.525,2.2,2.2,0,0,0-1.345.44,2.356,2.356,0,0,0-1.392-.44,2.43,2.43,0,0,0-1.708.665,2.3,2.3,0,0,0-.766,1.782v.434a3.918,3.918,0,0,0,.983,2.653h-.64L220,342.9h.5q3.987.025,5.423,3.089l.209.448.9-.424a6.906,6.906,0,0,0-4.115-3.8,2.952,2.952,0,0,1-2.259-2.964v-.434a1.454,1.454,0,0,1,1.459-1.452,1.37,1.37,0,0,1,.745.192,3.244,3.244,0,0,0-.5,1.8A2.886,2.886,0,0,0,222.958,341.218Zm.511-2.679a2.894,2.894,0,0,1,.566-.867,1.327,1.327,0,0,1,.878-.308,1.537,1.537,0,0,1,.974.339,1.23,1.23,0,0,1,.477.89c.008.123.016.249.016.374q0,2.107-1.593,2.1a1.411,1.411,0,0,1-1.026-.422,1.346,1.346,0,0,1-.425-1.024A3.507,3.507,0,0,1,223.469,338.539Z"
                  transform="translate(-164.272 -331.057)"
                  fill="#101820"
                />
                <path
                  id="Path_447"
                  data-name="Path 447"
                  d="M239.476,336.924a3.252,3.252,0,0,0-1.928-.542,4.3,4.3,0,0,0-.989.1,2.328,2.328,0,0,0-1.358.872,2.4,2.4,0,0,0-.5,1.47,2.212,2.212,0,0,0,.442,1.352l1.086-.17a2.625,2.625,0,0,1-.534-1.352,1.057,1.057,0,0,1,.638-1,2.561,2.561,0,0,1,1.223-.279c1.206,0,1.815.447,1.815,1.345V343.4q0,1.883-2.149,1.885a2.512,2.512,0,0,1-1.535-.431,1.7,1.7,0,0,1-.666-1.454,2.422,2.422,0,0,1,1.018-1.909h-1.149a4.729,4.729,0,0,0-.6.7,2.443,2.443,0,0,0-.243,1.2,2.634,2.634,0,0,0,.953,2.157,3.4,3.4,0,0,0,2.228.718,3.305,3.305,0,0,0,2.2-.71,2.681,2.681,0,0,0,.93-2.165v-4.682A2.06,2.06,0,0,0,239.476,336.924Z"
                  transform="translate(-166.863 -331.058)"
                  fill="#101820"
                />
                <path
                  id="Path_448"
                  data-name="Path 448"
                  d="M252.413,336.024a1.843,1.843,0,0,1-.643-.927,2.072,2.072,0,0,1-.067-.458v-1.352a1.469,1.469,0,0,0-1.465-1.459h-.488a.422.422,0,0,1-.484-.473h-.982a9.444,9.444,0,0,1-.308,2.46l-.123.477.959.248a14.059,14.059,0,0,0,.384-1.833,1.431,1.431,0,0,0,.559.11h.488a.413.413,0,0,1,.467.47c0,.92,0,1.4.011,1.447q-1.011.739-2.01,1.483a2.678,2.678,0,0,0-1.071,2.126,2.467,2.467,0,0,0,.956,2.046,3.618,3.618,0,0,0,4.261-.007,2.478,2.478,0,0,0,.956-2.039,2.287,2.287,0,0,0-.475-1.468A8.738,8.738,0,0,0,252.413,336.024Zm-.243,3.655a2.74,2.74,0,0,1-2.886,0,1.542,1.542,0,0,1-.668-1.337,1.62,1.62,0,0,1,.848-1.468,13.24,13.24,0,0,0,1.518-1.076,5.785,5.785,0,0,0,1.133,1.175,1.8,1.8,0,0,1,.713,1.369A1.554,1.554,0,0,1,252.171,339.68Z"
                  transform="translate(-169.318 -330.151)"
                  fill="#101820"
                />
                <path
                  id="Path_449"
                  data-name="Path 449"
                  d="M266.084,336.339a1.777,1.777,0,0,0-1.2.455,1.4,1.4,0,0,0-2.022-.047,1.364,1.364,0,0,0-.417.984c-.008.637-.2.958-.588.958a.567.567,0,0,1-.47-.248.735.735,0,0,1,.13-1.083c.066-.055.25-.188.558-.392l-.553-.82a4.9,4.9,0,0,0-.895.721,1.6,1.6,0,0,0-.4,1.065,1.806,1.806,0,0,0,.467,1.222,1.557,1.557,0,0,0,2.267.063,1.537,1.537,0,0,0,.465-1.1,2.207,2.207,0,0,1,.037-.507.41.41,0,0,1,.8.13v2.611h.981v-2.264a.787.787,0,0,1,.277-.541.856.856,0,0,1,1.431.632v5.178q0,1.885-2.151,1.885a2.522,2.522,0,0,1-1.533-.43,1.7,1.7,0,0,1-.668-1.455,1.672,1.672,0,0,1,.313-1.011,4.115,4.115,0,0,1,.76-.736l-.616-.774a4.933,4.933,0,0,0-1.034,1.081,2.6,2.6,0,0,0-.4,1.439,2.634,2.634,0,0,0,.956,2.157,3.4,3.4,0,0,0,2.225.718,3.313,3.313,0,0,0,2.206-.71,2.679,2.679,0,0,0,.928-2.165v-5.178a1.837,1.837,0,0,0-1.843-1.838Z"
                  transform="translate(-171.588 -331.015)"
                  fill="#101820"
                />
                <path
                  id="Path_450"
                  data-name="Path 450"
                  d="M279.569,341.49h1.159a6.084,6.084,0,0,0,.541-1.074,4.9,4.9,0,0,0,.178-1.47q0-2.562-1.671-2.564a1.348,1.348,0,0,0-1.05.438,1.617,1.617,0,0,0-1.128-.438,1.654,1.654,0,0,0-1.144.438,1.32,1.32,0,0,0-1.044-.438q-1.669,0-1.669,2.575a4.887,4.887,0,0,0,1.447,3.538c-.538.087-.938.161-1.206.225l.216.963a8.028,8.028,0,0,1,1.591-.229,5.749,5.749,0,0,1,1.276.146,5.362,5.362,0,0,1,3.369,2.851l.86-.486a7.166,7.166,0,0,0-1.729-2.1,8.2,8.2,0,0,0-2.583-1.295,3.034,3.034,0,0,1-1.517-1.3,4.071,4.071,0,0,1-.743-2.316c0-1.057.225-1.585.685-1.585q.521,0,.522.5v2.52h.981v-2.513a.427.427,0,0,1,.215-.362.843.843,0,0,1,.479-.147.819.819,0,0,1,.467.149.444.444,0,0,1,.214.368v2.5h.982v-2.513a.452.452,0,0,1,.514-.509c.452,0,.684.525.684,1.574a3.964,3.964,0,0,1-.75,2.342Z"
                  transform="translate(-174.027 -331.058)"
                  fill="#101820"
                />
                <path
                  id="Path_451"
                  data-name="Path 451"
                  d="M291.278,336.383a3,3,0,0,0-2.136.846,3.111,3.111,0,0,0-.987,2.084,4.408,4.408,0,0,0,.929,2.48l.3.393.781-.612a4.274,4.274,0,0,1-1.029-2.255,2.094,2.094,0,0,1,.693-1.388,2.142,2.142,0,0,1,3.58,1.388,4.273,4.273,0,0,1-1.024,2.255l.779.612a5.252,5.252,0,0,0,1.226-2.873,3.094,3.094,0,0,0-.981-2.084A3,3,0,0,0,291.278,336.383Z"
                  transform="translate(-176.627 -331.058)"
                  fill="#101820"
                />
                <path
                  id="Path_452"
                  data-name="Path 452"
                  d="M305.949,336.269a1.413,1.413,0,0,1-.859-.627,3.611,3.611,0,0,1-.364-1.006l-.959.241.119.48a2.322,2.322,0,0,0,1.039,1.46c.446.248.895.493,1.344.742a1.522,1.522,0,0,1,.664,1.337,1.568,1.568,0,0,1-.664,1.361,2.469,2.469,0,0,1-1.473.426,2.51,2.51,0,0,1-1.475-.418,1.581,1.581,0,0,1-.674-1.369,1.709,1.709,0,0,1,.234-.865l.247-.434-.849-.485a3.742,3.742,0,0,0-.614,1.783,2.5,2.5,0,0,0,.967,2.07,3.669,3.669,0,0,0,4.327,0,2.516,2.516,0,0,0,.956-2.07,2.724,2.724,0,0,0-1.966-2.627Z"
                  transform="translate(-179.065 -330.743)"
                  fill="#101820"
                />
                <path
                  id="Path_453"
                  data-name="Path 453"
                  d="M333.728,335.961c-.283-.216-.425-.386-.425-.511a.283.283,0,0,1,.32-.316h.5v-.989h-.493a1.248,1.248,0,0,0-.925.384,1.276,1.276,0,0,0,.046,1.867c.252.22.514.443.777.671a1.57,1.57,0,0,1,.418,1.115,1.592,1.592,0,0,1-.658,1.357,2.329,2.329,0,0,1-1.444.442,2.278,2.278,0,0,1-1.448-.45,1.6,1.6,0,0,1-.661-1.361v-7.425h-.982v7.425a2.573,2.573,0,0,0,.951,2.074,3.534,3.534,0,0,0,4.283,0,2.557,2.557,0,0,0,.942-2.068,2.517,2.517,0,0,0-.418-1.455A4.165,4.165,0,0,0,333.728,335.961Z"
                  transform="translate(-183.952 -330.041)"
                  fill="#101820"
                />
                <path
                  id="Path_454"
                  data-name="Path 454"
                  d="M346.506,336.269a1.434,1.434,0,0,1-.86-.627,3.742,3.742,0,0,1-.36-1.006l-.958.241.114.48a2.344,2.344,0,0,0,1.04,1.46l1.347.742a1.53,1.53,0,0,1,.666,1.337,1.572,1.572,0,0,1-.669,1.361,2.463,2.463,0,0,1-1.472.426,2.493,2.493,0,0,1-1.473-.418,1.58,1.58,0,0,1-.674-1.369,1.692,1.692,0,0,1,.234-.865l.244-.434-.848-.485a3.743,3.743,0,0,0-.611,1.783,2.5,2.5,0,0,0,.967,2.07,3.669,3.669,0,0,0,4.327,0,2.52,2.52,0,0,0,.961-2.07,2.734,2.734,0,0,0-1.974-2.627Z"
                  transform="translate(-186.383 -330.743)"
                  fill="#101820"
                />
                <path
                  id="Path_455"
                  data-name="Path 455"
                  d="M359.34,331.712l-.485.083.158.974a5.993,5.993,0,0,0,2.066-.666v3.873h-2.3a1.811,1.811,0,0,0-1.82,1.812,1.71,1.71,0,0,0,.8,1.5l.4.277.562-.815c-.3-.2-.472-.329-.534-.381a.784.784,0,0,1-.252-.575.808.808,0,0,1,.246-.585.787.787,0,0,1,.582-.24h2.314V342.2a1.656,1.656,0,0,1-.7,1.424,2.88,2.88,0,0,1-3.063,0,1.66,1.66,0,0,1-.707-1.424,1.627,1.627,0,0,1,.308-.988,4.2,4.2,0,0,1,.744-.726l-.628-.767a4.955,4.955,0,0,0-1.01,1.061,2.749,2.749,0,0,0,.6,3.546,3.759,3.759,0,0,0,4.441,0,2.566,2.566,0,0,0,.99-2.118V329.886c-.628.634-1.029,1.015-1.2,1.152A3.432,3.432,0,0,1,359.34,331.712Z"
                  transform="translate(-188.801 -329.886)"
                  fill="#101820"
                />
                <path
                  id="Path_456"
                  data-name="Path 456"
                  d="M373.543,336.269a1.424,1.424,0,0,1-.856-.627,3.719,3.719,0,0,1-.364-1.006l-.958.241.118.48a2.319,2.319,0,0,0,1.042,1.46l1.342.742a1.532,1.532,0,0,1,.67,1.337,1.578,1.578,0,0,1-.67,1.361,2.455,2.455,0,0,1-1.473.426,2.521,2.521,0,0,1-1.477-.418,1.578,1.578,0,0,1-.674-1.369,1.7,1.7,0,0,1,.235-.865l.248-.434-.852-.485a3.77,3.77,0,0,0-.611,1.783,2.506,2.506,0,0,0,.967,2.07,3.673,3.673,0,0,0,4.329,0,2.514,2.514,0,0,0,.953-2.07,2.678,2.678,0,0,0-.549-1.651A2.632,2.632,0,0,0,373.543,336.269Z"
                  transform="translate(-191.261 -330.743)"
                  fill="#101820"
                />
                <path
                  id="Path_457"
                  data-name="Path 457"
                  d="M387.319,335.366a2.031,2.031,0,0,0-1.569.69,1.945,1.945,0,0,0-1.546-.69h-.016a3.4,3.4,0,0,1,1.579-.811,3.328,3.328,0,0,0,1.888-1.186,3.293,3.293,0,0,0,.747-2.123v-.493h-.983v.5A2.361,2.361,0,0,1,386,333.367q-1.309.7-2.616,1.415a4.1,4.1,0,0,0-1.415,3.395,4.614,4.614,0,0,0,.911,2.585l.279.407.82-.556a4.7,4.7,0,0,1-1.029-2.436q0-1.822,1.242-1.82a1.385,1.385,0,0,1,.757.2.612.612,0,0,1,.311.53v2.4h.982v-2.328a.669.669,0,0,1,.348-.616,1.344,1.344,0,0,1,.728-.185q1.249,0,1.249,1.815a4.764,4.764,0,0,1-1.027,2.444l.817.554a5.635,5.635,0,0,0,1.191-3,3.335,3.335,0,0,0-.509-1.905A1.937,1.937,0,0,0,387.319,335.366Z"
                  transform="translate(-193.554 -330.042)"
                  fill="#101820"
                />
                <path
                  id="Path_458"
                  data-name="Path 458"
                  d="M400.9,336.354a1.8,1.8,0,0,0-1.338.564,2.328,2.328,0,0,0-1.543-.564,2.285,2.285,0,0,0-1.687.7,2.394,2.394,0,0,0-.725,1.695c-.008.407-.008.689,0,.843.017.232.041.4.057.52h0a2.424,2.424,0,0,0,2.35,1.869,2.292,2.292,0,0,0,1.7-.711,2.389,2.389,0,0,0,.715-1.694,4.309,4.309,0,0,0-.256-1.831.86.86,0,0,1,.729-.4.943.943,0,0,1,.87.67,2.782,2.782,0,0,1,.232,1.152,2.668,2.668,0,0,1-.319,1.3,5.376,5.376,0,0,1-.824,1.033l.709.689a5.957,5.957,0,0,0,1.029-1.363,3.586,3.586,0,0,0,.386-1.66,3.466,3.466,0,0,0-.49-1.87A1.777,1.777,0,0,0,400.9,336.354Zm-1.45,3.209a1.391,1.391,0,0,1-.43,1.011,1.371,1.371,0,0,1-1,.418,1.388,1.388,0,0,1-.9-.319,1.424,1.424,0,0,1-.5-.793c-.018-.223-.025-.348-.025-.379v-.712a1.422,1.422,0,0,1,.422-1.016,1.356,1.356,0,0,1,1.006-.428,1.47,1.47,0,0,1,1.188.647,2.075,2.075,0,0,1,.243.757C399.462,338.822,399.462,339.094,399.454,339.563Z"
                  transform="translate(-196.013 -331.053)"
                  fill="#101820"
                />
                <path
                  id="Path_459"
                  data-name="Path 459"
                  d="M414.222,336.445a5.429,5.429,0,0,0-.927-.063,4.329,4.329,0,0,0-.988.1,2.5,2.5,0,0,0-1.321.8,1.969,1.969,0,0,0-.533,1.4,2.647,2.647,0,0,0,.436,1.491l1.089-.17a2.56,2.56,0,0,1-.543-1.352,1.055,1.055,0,0,1,.638-1,2.558,2.558,0,0,1,1.222-.279q1.81,0,1.812,1.345v.2a1.361,1.361,0,0,1-1.329,1.332h-.97v.972h1.123a1.029,1.029,0,0,1,.823.4,1.441,1.441,0,0,1,.352.932,3.973,3.973,0,0,1-.334,2,1.959,1.959,0,0,1-1.8.733,2.5,2.5,0,0,1-1.535-.431,1.7,1.7,0,0,1-.671-1.454,1.768,1.768,0,0,1,.7-1.439l.379-.308-1.26-.161c-.171.221-.336.442-.5.657a2.445,2.445,0,0,0-.3,1.252,2.623,2.623,0,0,0,.961,2.157,3.385,3.385,0,0,0,2.223.718,3.331,3.331,0,0,0,2.209-.718,2.633,2.633,0,0,0,.919-2.157v-.849a2.239,2.239,0,0,0-.906-1.825,2.067,2.067,0,0,0,.906-1.81v-.2a2.313,2.313,0,0,0-1.869-2.272Z"
                  transform="translate(-198.571 -331.058)"
                  fill="#101820"
                />
                <path
                  id="Path_460"
                  data-name="Path 460"
                  d="M428.745,336.924a3.231,3.231,0,0,0-1.924-.542,4.282,4.282,0,0,0-.99.1,2.3,2.3,0,0,0-1.355.872,2.368,2.368,0,0,0-.508,1.47,2.212,2.212,0,0,0,.443,1.352l1.092-.17a2.553,2.553,0,0,1-.538-1.352,1.057,1.057,0,0,1,.638-1,2.545,2.545,0,0,1,1.224-.279c1.206,0,1.812.447,1.812,1.345V343.4q0,1.883-2.149,1.885a2.511,2.511,0,0,1-1.536-.431,1.693,1.693,0,0,1-.666-1.454,2.421,2.421,0,0,1,1.019-1.909h-1.151a5.074,5.074,0,0,0-.6.7,2.471,2.471,0,0,0-.243,1.2,2.643,2.643,0,0,0,.952,2.157,3.417,3.417,0,0,0,2.231.718,3.305,3.305,0,0,0,2.2-.71,2.683,2.683,0,0,0,.929-2.165v-4.682A2.059,2.059,0,0,0,428.745,336.924Z"
                  transform="translate(-201.011 -331.058)"
                  fill="#101820"
                />
                <path
                  id="Path_461"
                  data-name="Path 461"
                  d="M441.8,341.49h1.159a6.325,6.325,0,0,0,.541-1.074,4.981,4.981,0,0,0,.178-1.47q0-2.562-1.671-2.564a1.338,1.338,0,0,0-1.047.438,1.628,1.628,0,0,0-1.131-.438,1.658,1.658,0,0,0-1.143.438,1.327,1.327,0,0,0-1.045-.438q-1.67,0-1.668,2.575a4.907,4.907,0,0,0,1.443,3.538c-.538.087-.934.161-1.2.225l.216.963a8.054,8.054,0,0,1,1.594-.229,5.783,5.783,0,0,1,1.274.146,5.364,5.364,0,0,1,3.369,2.851l.856-.486a7.145,7.145,0,0,0-1.726-2.1,8.209,8.209,0,0,0-2.58-1.295,3.019,3.019,0,0,1-1.518-1.3,4.061,4.061,0,0,1-.744-2.316c0-1.057.23-1.585.682-1.585q.525,0,.525.5v2.52h.981v-2.513a.432.432,0,0,1,.215-.362.841.841,0,0,1,.478-.147.807.807,0,0,1,.467.149.442.442,0,0,1,.214.368v2.5h.983v-2.513a.452.452,0,0,1,.514-.509q.685,0,.684,1.574a3.966,3.966,0,0,1-.747,2.342Z"
                  transform="translate(-203.296 -331.058)"
                  fill="#101820"
                />
                <path
                  id="Path_462"
                  data-name="Path 462"
                  d="M454.916,336.382a2.031,2.031,0,0,0-1.569.69,2.1,2.1,0,0,0-3.267.2,3.385,3.385,0,0,0-.511,1.911,5.655,5.655,0,0,0,1.191,3l.82-.558a4.709,4.709,0,0,1-1.029-2.439c0-1.206.418-1.81,1.246-1.81a1.414,1.414,0,0,1,.757.193.6.6,0,0,1,.308.525v2.41h.982v-2.363a.64.64,0,0,1,.352-.588,1.4,1.4,0,0,1,.719-.178q1.254,0,1.254,1.81a4.72,4.72,0,0,1-1.026,2.439l.815.558a5.6,5.6,0,0,0,1.193-3,3.379,3.379,0,0,0-.509-1.911A1.947,1.947,0,0,0,454.916,336.382Z"
                  transform="translate(-205.749 -331.058)"
                  fill="#101820"
                />
                <path
                  id="Path_463"
                  data-name="Path 463"
                  d="M468.646,330.743a1.825,1.825,0,0,0-1.511.742,2.251,2.251,0,0,0-3.914,1.506,2.194,2.194,0,0,0,.71,1.64l.363.34.679-.718a7.323,7.323,0,0,1-.533-.544,1.18,1.18,0,0,1-.237-.718,1.216,1.216,0,0,1,.368-.888,1.249,1.249,0,0,1,.906-.371,1.272,1.272,0,0,1,1.266,1.259v1.293h.982v-1.609a.91.91,0,0,1,.271-.669.885.885,0,0,1,.656-.275.95.95,0,0,1,.943.943v3.446a2.99,2.99,0,0,0-2.047-.642,3.231,3.231,0,0,0-2.118.7,2.52,2.52,0,0,0-.927,2.047,2.492,2.492,0,0,0,.927,2.032,3.523,3.523,0,0,0,4.228,0,2.5,2.5,0,0,0,.924-2.032v-5.557a1.943,1.943,0,0,0-1.935-1.933Zm.314,8.819a2.6,2.6,0,0,1-2.828,0,1.55,1.55,0,0,1-.647-1.329,1.568,1.568,0,0,1,.634-1.338,2.329,2.329,0,0,1,1.429-.425,2.293,2.293,0,0,1,1.437.434,1.6,1.6,0,0,1,.611,1.329A1.566,1.566,0,0,1,468.96,339.562Z"
                  transform="translate(-208.212 -330.041)"
                  fill="#101820"
                />
                <path
                  id="Path_464"
                  data-name="Path 464"
                  d="M480.55,336.383a3,3,0,0,0-2.136.846,3.1,3.1,0,0,0-.987,2.084,4.4,4.4,0,0,0,.926,2.48l.3.393.78-.612a4.253,4.253,0,0,1-1.029-2.255,2.09,2.09,0,0,1,.692-1.388,2.142,2.142,0,0,1,3.58,1.388,4.241,4.241,0,0,1-1.029,2.255l.783.612a5.231,5.231,0,0,0,1.228-2.873,3.107,3.107,0,0,0-.983-2.084A2.994,2.994,0,0,0,480.55,336.383Z"
                  transform="translate(-210.776 -331.058)"
                  fill="#101820"
                />
                <path
                  id="Path_465"
                  data-name="Path 465"
                  d="M498.8,334.714V331c.313-.029.47-.19.47-.478,0-.316-.193-.473-.588-.473h-.97l-1.185,2.87-1.2-2.87h-.967c-.391,0-.587.157-.587.473,0,.288.157.449.473.478v3.718c-.366,0-.548.16-.548.478s.2.47.588.47h1.159c.392,0,.586-.157.586-.47a.474.474,0,0,0-.155-.363.619.619,0,0,0-.431-.115h-.319v-2.823l1.021,2.444h.769l1-2.45v2.828H497.6q-.588,0-.588.478t.588.47h1.159q.588,0,.588-.47C499.35,334.874,499.165,334.714,498.8,334.714Z"
                  transform="translate(-213.712 -329.915)"
                  fill="#101820"
                />
                <path
                  id="Path_466"
                  data-name="Path 466"
                  d="M492.724,330.045h-4.558V331.9c0,.42.148.631.441.631s.441-.211.441-.631V331H490v3.718h-.588q-.588,0-.588.5c0,.3.2.447.588.447h2.063c.391,0,.588-.157.588-.47s-.2-.478-.588-.478h-.6V331h.966v.906c0,.42.149.631.442.631s.438-.211.438-.631Z"
                  transform="translate(-212.713 -329.915)"
                  fill="#101820"
                />
              </g>
            </g>
          </svg>
         
        </div>
        <div class="see-below">
            <h2 class="f-55">{{$fn.tr('გამომთვლელი')}}</h2>
            <svg xmlns="http://www.w3.org/2000/svg" width="63.209" height="86.988" viewBox="0 0 63.209 86.988">
  <g id="Group_507" data-name="Group 507" transform="translate(-931.397 -2539.134)">
    <g id="Group_506" data-name="Group 506" transform="translate(996.74 2565.506) rotate(90)">
      <g id="menu" transform="translate(-24.753 3.741)">
        <g id="Group_103" data-name="Group 103" transform="translate(0 0)">
          <path id="Union_6" data-name="Union 6" d="M38.836,50.775A159.541,159.541,0,0,1,59.1,36.62c1.957-1.16,3.963-2.27,6.028-3.235-2.987-.123-6.036,0-9.054.123-3.205.134-6.374.257-9.4.107-13.063-.706-25.993-3.1-39.1-2.855-4.508.075-11.909-6.68-4.27-6.822,14.862-.275,29.436,2.673,44.259,2.989,2.457.045,4.968-.008,7.506-.07,5.6-.115,11.322-.238,16.76.8-7.321-7.7-15.705-14.369-22.011-23.009-1.894-2.588-.389-6.843,2.2-3.285,7.592,10.42,18.249,18,26.392,27.946a4.275,4.275,0,0,1,.678,1.16,3.4,3.4,0,0,1,1.072,2.6c0,.115-.008.222-.008.323-.065,1.959-2.866,2.363-5.663,1.714-5.3.781-10.208,3.849-14.621,6.707a179.392,179.392,0,0,0-16.7,11.912,3.841,3.841,0,0,1-2.45.815C38.429,54.541,36.346,52.828,38.836,50.775Z" transform="matrix(0.998, -0.07, 0.07, 0.998, 0, 5.592)" fill="#fff" stroke="#fff" stroke-width="3"/>
        </g>
      </g>
    </g>
  </g>
</svg>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import prlx from "@/mixins/ik_prlx";

export default {
  props: ['contentData'],
    mixins: [prlx],
  computed: {
    video_url(){
      return this.contentData.data.list[0].video.videoFile.url;
    }
  },
  mounted(){
    if(this.contentData.data.list[0].video && this.contentData.data.list[0].video.videoFile && this.contentData.data.list[0].video.videoFile.url){
         let v = this.$refs.bar_block_video;
        v.addEventListener('loadeddata', () => {
            v.play();
        })
        v.muted = true;
    }
     
  }
};
</script>

<style lang="scss" scoped>
.bar .history-block-bar .text-block .editor-bar{
  &::v-deep p, &::v-deep span, &::v-deep h1, &::v-deep h2, &::v-deep h3, &::v-deep h4, &::v-deep h5, &::v-deep h6, &::v-deep strong, &::v-deep i, &::v-deep mark, &::v-deep em,
   &::v-deep small, &::v-deep del, &::v-deep ins, &::v-deep sub, &::v-deep sup
   {
    
      font-family: "FiraGO-Italic";
   }
}
.b__v{
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
}
</style>
